import React from 'react';
import THEME from '../utils/theme';
import { CAT_META } from '../utils/helpers';

// ── Social icons
import { FaFacebookF, FaYoutube, FaWhatsapp } from 'react-icons/fa';

// ── Contact icons
import { MdEmail, MdPhone, MdLocationOn } from 'react-icons/md';

const socialLinks = [
  { label: 'Facebook', icon: FaFacebookF, href: '#' },
  { label: 'YouTube',  icon: FaYoutube,   href: '#' },
  { label: 'WhatsApp', icon: FaWhatsapp,  href: '#' },
];

const contactItems = [
  { icon: MdEmail,      text: 'info@skilltojapanbd.com'                              },
  { icon: MdPhone,      text: '+88013-34112222'                                       },
  { icon: MdLocationOn, text: 'Sector 7, Road 34, House No: 16/A, Lift 4th Floor, Uttara Dhaka' },
];

export default function Footer() {
  return (
    <footer style={{
      background: THEME.navy,
      color: 'rgba(255,255,255,0.6)',
      padding: '72px clamp(20px,4vw,40px) 32px',
    }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div className="sk-footer-grid" style={{
          display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr',
          gap: 48, marginBottom: 56,
        }}>

          {/* ── Brand ── */}
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
              <div>
                <div style={{ fontFamily:"'Syne',sans-serif", fontWeight: 800, fontSize: 17, color: 'white' }}>
                  Skill to Japan BD
                </div>
                <div style={{ fontSize: 11, color: THEME.red, fontWeight: 600, letterSpacing: '0.08em' }}>
                  Your Path to Japan
                </div>
              </div>
            </div>

            <p style={{ fontSize: 14, lineHeight: 1.85, maxWidth: 280 }}>
              We help Bangladeshi youth build successful careers in Japan through professional training in language, trade, and technical skills.
            </p>

            {/* Social icons */}
            <div style={{ display: 'flex', gap: 10, marginTop: 22 }}>
              {socialLinks.map(s => {
                const Icon = s.icon;
                return (
                  <a key={s.label} href={s.href} title={s.label} style={{
                    width: 38, height: 38, borderRadius: 6,
                    background: 'rgba(255,255,255,0.08)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    color: 'rgba(255,255,255,0.7)', textDecoration: 'none',
                    transition: 'background 0.2s',
                  }}
                    onMouseEnter={e => e.currentTarget.style.background = THEME.red}
                    onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.08)'}>
                    <Icon size={16} />
                  </a>
                );
              })}
            </div>
          </div>

          {/* ── Quick Links ── */}
          <div>
            <div style={{ fontFamily:"'Syne',sans-serif", color: 'white', fontWeight: 700, fontSize: 14, marginBottom: 20, letterSpacing: '0.06em' }}>
              Quick Links
            </div>
            {[
              { href: '#courses', label: 'Our Courses'     },
              { href: '#batches', label: 'Batch Schedule'  },
              { href: '#stories', label: 'Success Stories' },
              { href: '#notices', label: 'Notice Board'    },
              { href: '#videos',  label: 'Video Gallery'   },
              { href: '#apply',   label: 'Apply Now'       },
            ].map(l => (
              <a key={l.href} href={l.href} style={{
                display: 'block', textDecoration: 'none',
                color: 'rgba(255,255,255,0.55)', fontSize: 14, marginBottom: 10,
                transition: 'color 0.2s',
              }}
                onMouseEnter={e => e.target.style.color = THEME.red}
                onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.55)'}>
                → {l.label}
              </a>
            ))}
          </div>

          {/* ── Courses (CAT_META) ── */}
          <div>
            <div style={{ fontFamily:"'Syne',sans-serif", color: 'white', fontWeight: 700, fontSize: 14, marginBottom: 20, letterSpacing: '0.06em' }}>
              Courses
            </div>
            {Object.values(CAT_META).map(c => {
              const Icon = c.icon; // CAT_META এর icon এখন react-icon component হবে
              return (
                <div key={c.label} style={{
                  display: 'flex', alignItems: 'center', gap: 8,
                  fontSize: 14, color: 'rgba(255,255,255,0.55)', marginBottom: 10,
                }}>
                  <Icon size={15} color={c.color || 'rgba(255,255,255,0.55)'} style={{ flexShrink: 0 }} />
                  <span>{c.label}</span>
                </div>
              );
            })}
          </div>

          {/* ── Contact ── */}
          <div>
            <div style={{ fontFamily:"'Syne',sans-serif", color: 'white', fontWeight: 700, fontSize: 14, marginBottom: 20, letterSpacing: '0.06em' }}>
              Contact
            </div>
            {contactItems.map(c => {
              const Icon = c.icon;
              return (
                <div key={c.text} style={{
                  display: 'flex', gap: 10, marginBottom: 12,
                  fontSize: 14, color: 'rgba(255,255,255,0.55)', alignItems: 'flex-start',
                }}>
                  <Icon size={17} style={{ flexShrink: 0, marginTop: 2 }} color="rgba(255,255,255,0.55)" />
                  <span>{c.text}</span>
                </div>
              );
            })}
          </div>

        </div>

        {/* ── Bottom bar ── */}
        <div style={{
          borderTop: '1px solid rgba(255,255,255,0.08)', paddingTop: 28,
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          flexWrap: 'wrap', gap: 12, fontSize: 13,
        }}>
          <span>© 2024 Skill to Japan BD. All rights reserved.</span>
          <span style={{
            fontFamily: "'Noto Serif', serif", fontStyle: 'italic',
            color: 'rgba(255,255,255,0.25)',
          }}>
            技能で夢の日本へ — Skill to Japan BD
          </span>
        </div>
      </div>

      <style>{`
        @media (max-width: 900px) { .sk-footer-grid { grid-template-columns: 1fr 1fr !important; gap: 36px !important; } }
        @media (max-width: 480px) { .sk-footer-grid { grid-template-columns: 1fr !important; } }
      `}</style>
    </footer>
  );
}